import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";
const DeliveryDispatchCLForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});

  const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [expectedDate, setexpectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleExpectedDateChange = (e) => {
    setexpectedDate(e.target.value);
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();
  const rangeRef = useRef({});
  const [rangeDetails, setRangeDetails] = useState([]);
  const [selectedRangeDetails, setselectedRangeDetails] = useState([]);
  const [rangeClose, setRangeClose] = useState(false);
  const [salesorderlist, setsalesorderlist] = useState([]);
  const [salesOrderId, setsalesOrderId] = useState();
  const [containerLoadinglist, setcontainerLoadinglist] = useState([]);
  const [containerLoadingId, setcontainerLoadingId] = useState();
  const [latLongclose, setLatLongclose] = useState(false);

  const [vehiclelist, setVehiclelist] = useState(null);
  const [vmerId, setvmerId] = useState();
  const [selectedProductId, setselectedProductId] = useState();

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getVehicle } = useHttp();
  useEffect(() => {
    getVehicle(
      {
        url: "/api/vehicleMachineEquipRegistratn/",
      },
      (res) => {
        if (res) {
          var vehicle = res.filter((x) => x.vmeClassific == "Vehicle");
          //console.log(vehicle);
          setVehiclelist(vehicle);
        }
      }
    );
  }, [getVehicle]);

  const { sendRequest: getSalesOrder } = useHttp();
  useEffect(() => {
    getSalesOrder(
      {
        url: `/api/salesOrderPending/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("salesOrder", data);
        setsalesorderlist(data);
      }
    );
  }, [getSalesOrder]);

  const { sendRequest: getcontainerDetail } = useHttp();
  useEffect(() => {
    getcontainerDetail(
      {
        url: `/api/containerLoadingForDeliveryDispatch/?warehouseId=${localStorage.getItem(
          "warehouseId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("setcontainerLoading", data);
        setcontainerLoadinglist(data.ContainerLoading);
      }
    );
  }, [getcontainerDetail]);

  const { sendRequest: getSalesOrderProduct } = useHttp();

  const salesOrderOnChaged = (id) => {
    frmRef.current.shipp_address.value = "";
    frmRef.current.city.value = "";
    frmRef.current.state.value = "";
    frmRef.current.country.value = "";
    frmRef.current.zip_code.value = "";

    var itemlist = salesorderlist.filter((item) => item.salesOrderId == id);
    if (itemlist.length > 0) {
      var selectedSalesItem = itemlist[0];
      //console.log(selectedSalesItem);
      frmRef.current.shipp_address.value = selectedSalesItem.shippingAddress;
      frmRef.current.city.value = selectedSalesItem.shippingCity;
      frmRef.current.state.value = selectedSalesItem.shippingState;
      frmRef.current.country.value = selectedSalesItem.shippingCountry;
      frmRef.current.zip_code.value = selectedSalesItem.shippingZip;
      setLatLongclose(selectedSalesItem.shippingLatLong);
      getSalesOrderProduct(
        {
          url: `/api/getSalesOrderProduct/?salesOrderId=${selectedSalesItem.salesOrderId}`,
        },
        (res) => {
          if (res) {
            //console.log("SalesOrder", res);
            var newfinalList = [];
            var i = 0;

            do {
              var item = res[i];
              var newfinalList = newfinalList.concat({
                productId: item.productId,
                productName: item.productName,
                quantity: item.salesOrderQuantityBalance,
                salesOrderProductId: item.salesOrderProductId,
                productId: item.productId,
                linesrno: item.lineSrNo,
                deliveryDispatchQuantity: 0,
                deliveryDispatchQuantityBalance: 0,
                unitAbbreviation: item.unitAbbreviation,
                unitId: item.unitId,
                palletBoxDetail: "",
                palletDetail: "",
                totalGrossWeight: 0,
                totalNetWeight: 0,
                grossNetUnitId: 0,
                productCost: 0,
                status: 1,
                createdBy: parseInt(localStorage.getItem("id")),
                orgId: localStorage.getItem("orgId"),
                itemId: item.itemId,
                productSubTypeName: item.productSubTypeName,
                varietyName: item.varietyName,
              });

              i++;
            } while (res.length > i);

            setProductDetails(newfinalList);
          }
        }
      );
    }
  };

  const containerNoOnChaged = (id) => {
    var itemlist = containerLoadinglist.filter(
      (item) => item.containerLoadingId == id
    );
    if (itemlist.length > 0) {
      var selectedContainerItem = itemlist[0];

      getSalesOrderProduct(
        {
          url: `/api/containerLoadingProduct/?containerLoadingId=${selectedContainerItem.containerLoadingId}`,
        },
        (res) => {
          if (res) {
            //console.log("containerLoadingProduct", res.ContainerLoadingProduct);

            var containerLoadingProduct = res.ContainerLoadingProduct;
            //setRangeDetails(res.ContainerLoadingProduct);

            var newfinalList = [];
            var i = 0;

            do {
              var item = containerLoadingProduct[i];

              var productlist = JSON.parse(
                JSON.stringify(item.palletProductDetail)
              );
              var k = 0;

              //console.log("productlist", productlist.length);

              do {
                var productItem = productlist[k];

                var newfinalList = newfinalList.concat({
                  Iselected: false,
                  containerLoadingProductId: item.containerLoadingProductId,
                  palletNo: item.palletNo,
                  productId: productItem.productId,
                  palletListId: item.palletListId,
                  palletBoxDetail: item.palletBoxDetail,
                  productName: productItem.productName,
                  quantity: productItem.boxQuantity,
                  stockQuantity: productItem.boxQuantity,
                  stockQuantityBalance: productItem.boxQuantity,
                  unitId: productItem.boxQuantity,
                  productCost: productItem.productCost,
                  grossNetUnitId: productItem.grossNetUnitId,
                  status: 1,
                  createdBy: parseInt(localStorage.getItem("id")),
                  orgId: localStorage.getItem("orgId"),
                });
                k++;
              } while (productlist.length > k);

              i++;
            } while (containerLoadingProduct.length > i);

            //console.log("newfinalList", newfinalList);
            setRangeDetails(newfinalList);
          }
        }
      );
    }
  };

  const handleSelect = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    // var newselectList = farmerSelectListData;

    // if (isChecked) {

    //   const now = new Date();
    //   var fliterlist = farmerListData.filter((item) => item.farmerId == value);
    //   const secondsSinceEpoch = Math.round(now.getTime() / 1000)

    //  // //console.log("fliterlist", fliterlist)
    //   newselectList = newselectList.concat({
    //     beatPlanId:  secondsSinceEpoch,
    //     farmerId: value,
    //     farmerName: fliterlist && fliterlist[0].farmerName,
    //       coordinates: "{\"latitude\":0.0,\"longitude\":0.0}",//fliterlist && fliterlist[0].coordinates,
    //     date:SelectedDate ,
    //     taskId: 0,
    //     taskName:"",
    //     description: "",
    //     createdBy: parseInt(localStorage.getItem("id")),
    //     warehouseId: parseInt(localStorage.getItem("warehouseId")),
    //     orgId: localStorage.getItem("orgId")
    //   });

    //   setFarmerSelectListData(newselectList)

    // } else {

    //   newselectList = newselectList.filter((item) => item.farmerId !== value);
    //   setFarmerSelectListData(newselectList);
    // }
    // //console.log("newselectList", newselectList)
  };

  const LoadVehicleData = (id) => {
    frmRef.current.driver_name.value = "";
    frmRef.current.driverContactNo.value = "";

    var itemlist = vehiclelist.filter((item) => item.vmerId == id);
    var selectedItem = itemlist[0];

    frmRef.current.driver_name.value = itemlist[0].assignedPersonDriverName;
    frmRef.current.driverContactNo.value = itemlist[0].assignedPersonContactNo;
  };

  const { sendRequest: postDeliveryDispatch } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      dndDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      supervisorEmployeeId: assignEmployeeId,
      timeStamp: frmRef.current.packingTime.value,
      productDetails: productDetails,
      salesOrderId: salesOrderId,
      clId: containerLoadingId,
      vehicleId: vmerId,
      driverName: frmRef.current.driver_name.value,
      driverContactNo: frmRef.current.driverContactNo.value,
      shippingAdd: frmRef.current.shipp_address.value,
      city: frmRef.current.city.value,
      state: frmRef.current.state.value,
      zipCode: frmRef.current.zip_code.value,
      country: frmRef.current.country.value,
      latLong: latLongclose,
      estimatedDeliveryDate: moment(
        frmRef.current.estimated_delivery_date.value
      ).format("DD/MM/YYYY"),
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };
    if (props.update) {
      data["dndId"] = props.update.dndId;
    }
    //console.log(data);

    postDeliveryDispatch(
      {
        url: "/api/deliveryDispatch/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(`Delievry dispatch entry added.`);
        setLoading(false);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = moment(props.update.dndDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      setProductDetails(props.update.productDetails);
      frmRef.current.sales_order_id.value = props.update.salesOrderId;
      setRangeDetails(props.update.palletIdRange);

      frmRef.current.gate_pass_id.value = props.update.gatepassId;

      frmRef.current.seal_number.value = props.update.sealNo;
      frmRef.current.container_number.value = props.update.containerNo;
      frmRef.current.vehicle_id.value = props.update.vehicleId;
      frmRef.current.driver_name.value = props.update.driverName;
      frmRef.current.driver_contact_number.value = props.update.driverContactNo;
      frmRef.current.shipp_address.value = props.update.shippingAdd;

      frmRef.current.city.value = props.update.city;
      frmRef.current.state.value = props.update.state;
      frmRef.current.zip_code.value = props.update.zipCode;
      frmRef.current.country.value = props.update.country;
      frmRef.current.lat_long.value = props.update.latLong;
      frmRef.current.estimated_delivery_date.value = moment(
        props.update.estimatedDeliveryDate
      ).format("YYYY-MM-DD");

      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);
  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,

        itemDescription: productRef.current.itemDescription.value,
        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        unit: productRef.current.unit.value,
      },
    ]);

    //console.log(productDetails);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const submitRange = (e) => {
    e.preventDefault();
    setRangeDetails((x) => [
      ...x,
      {
        itemIdFrom: rangeRef.current.item_id_from.value,
        itemIdTo: rangeRef.current.item_id_to.value,
        siItemId: rangeRef.current.si_item_id.value,
        excludedItemId: rangeRef.current.excluded_item_id.value,
      },
    ]);

    //console.log(rangeDetails);
  };

  const handleRangeDelete = (index, e) => {
    setRangeDetails(rangeDetails.filter((v, i) => i !== index));
  };

  return (
    <>
      {close && (
        <Modal isOpen={close} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Product Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Product Name</th>
                    <th>Item Id</th>
                    <th>Item Category</th>
                    <th>Item Variety</th>
                    <th>Item Quantity</th>
                    <th>Dispatch Quantity</th>
                    <th>Unit</th>
                    <th>Pallet</th>
                  </tr>
                </thead>
                <tbody>
                  {productDetails &&
                    productDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.itemId}</td>
                          <td>{itm.productSubTypeName}</td>
                          <td>{itm.varietyName}</td>
                          <td>{itm.quantity}</td>
                          <td>{itm.deliveryDispatchQuantity}</td>
                          <td>{itm.unitAbbreviation}</td>
                          <td>
                            <button
                              className="btn  btn-primary mx-2 my-2"
                              formNoValidate="True"
                              onClick={(e) => {
                                e.preventDefault(false);
                                setselectedProductId(itm.productId);
                                setselectedRangeDetails(
                                  rangeDetails &&
                                    rangeDetails.filter(
                                      (x) => x.productId == itm.productId
                                    )
                                );
                                setRangeClose(true);
                              }}
                            >
                              Add Pallet
                            </button>
                          </td>
                        </tr>
                      );
                    })}

                  <tr>
                    <td colSpan={9}>
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        onClick={() => {
                          productDetails.map((x) => (x["isSave"] = true));
                          setClose(false);
                        }}
                      >
                        Save
                      </button>{" "}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
      )}

      {rangeClose && (
        <Modal isOpen={rangeClose} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Pallet Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setRangeClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Select </th>
                    <th>Pallet No </th>
                    <th>Product Name</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedRangeDetails &&
                    selectedRangeDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <input
                              type="checkbox"
                              name="languages"
                              defaultChecked={selectedRangeDetails[i].Iselected}
                              onChange={(e) => {
                                selectedRangeDetails[i].Iselected =
                                  e.target.checked;
                              }}
                            />
                          </td>
                          <td>{itm.palletNo}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.quantity}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>{" "}
            </div>
            <div className="row">
              <div className="col-md-5"></div>

              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    var pallet =
                      selectedRangeDetails &&
                      selectedRangeDetails.filter((x) => x.Iselected);

                    //console.log("pallet", pallet);

                    var dispatchQty = pallet.reduce(
                      (a, v) => (a = a + v.quantity),
                      0
                    );
                    var otherpallet =
                      rangeDetails &&
                      rangeDetails.filter(
                        (x) => x.productId != selectedProductId
                      );

                    setRangeDetails([...selectedRangeDetails, ...otherpallet]);

                    var i = 0;
                    var grossNetUnitId;
                    do {
                      grossNetUnitId = pallet[0].grossNetUnitId;
                      var productItem = productDetails[i];

                      if (productItem.productId == selectedProductId) {
                        productDetails[i].deliveryDispatchQuantity =
                          dispatchQty;
                        productDetails[i].deliveryDispatchQuantityBalance =
                          dispatchQty;
                        productDetails[i].palletDetail = pallet;
                        productDetails[i].grossNetUnitId = grossNetUnitId;
                      }
                      i++;
                    } while (productDetails.length > i);
                    setProductDetails(productDetails);
                    setRangeClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">
                    Delivery & Dispatch - Container Loading
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />{" "}
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"packing_time"}>
                        Delivery & Dispatch Time
                      </label>

                      <input
                        type={"time"}
                        id={"packingTime"}
                        required
                        ref={(el) => (frmRef.current["packingTime"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Packhouse Employee"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option>--Select Employee--</option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"salesOrderId"}>{"Sales Order No"}</label>
                      <select
                        id="salesOrderId"
                        className="form-control"
                        ref={(el) => (frmRef.current["salesOrderId"] = el)}
                        value={salesOrderId}
                        onChange={(e) => {
                          setsalesOrderId(e.target.value);
                          salesOrderOnChaged(e.target.value);
                        }}
                      >
                        <option>--Select Sales Order--</option>
                        {salesorderlist &&
                          salesorderlist.map((x) => (
                            <option
                              key={x.salesOrderId}
                              salesOrder-id={x.salesOrderId}
                              value={x.salesOrderId}
                            >
                              {x.salesOrderCode}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"ContainerNo"}>
                        {"Container Number"}
                      </label>

                      <select
                        id="containerLoadingId"
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["containerLoadingId"] = el)
                        }
                        value={containerLoadingId}
                        onChange={(e) => {
                          setcontainerLoadingId(e.target.value);
                          containerNoOnChaged(e.target.value);
                        }}
                      >
                        <option>--Select Container No--</option>
                        {containerLoadinglist &&
                          containerLoadinglist.map((x) => (
                            <option
                              key={x.containerLoadingId}
                              containerLoading-id={x.containerLoadingId}
                              value={x.containerLoadingId}
                            >
                              {x.containerLoadingNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      <button
                        type={"button"}
                        id={"Product_details"}
                        onClick={(e) => {
                          e.preventDefault(false);
                          setClose(true);
                        }}
                        className="btn btn-sm  btn-success mx-2 my-2"
                      >
                        Add
                      </button>
                      {/* <input
                type={"text"}
                id={"product_details"}
                autoComplete="off"

                
                onClick={() => {
                   
                  //console.log("ABCD")
                  setClose(true);
                }}
                ref={(el) => (frmRef.current["product_details"] = el)}
                className="form-control"
              />
               */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"vehicle_id"}>{"Vehicle id"}</label>
                      <select
                        id="vmerId"
                        className="form-control"
                        ref={(el) => (frmRef.current["vmerId"] = el)}
                        value={vmerId}
                        onChange={(e) => {
                          setvmerId(e.target.value);
                          LoadVehicleData(e.target.value);
                        }}
                      >
                        <option>--Select Vehicle --</option>
                        {vehiclelist &&
                          vehiclelist.map((x) => (
                            <option
                              key={x.vmerId}
                              vmer-id={x.vmerId}
                              value={x.vmerId}
                            >
                              {x.vmeNo}
                            </option>
                          ))}
                      </select>{" "}
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"driver_name"}>{"Driver Name"}</label>
                      <input
                        type={"text"}
                        id={"driver_name"}
                        required
                        ref={(el) => (frmRef.current["driver_name"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"driverContactNo"}>
                        {"Driver Contact No "}
                      </label>
                      <input
                        type={"text"}
                        id={"driverContactNo"}
                        required
                        ref={(el) => (frmRef.current["driverContactNo"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"shipp_address"}>
                        {"Shipping Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_address"}
                        autocomplete="off"
                        required
                        ref={(el) => (frmRef.current["shipp_address"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"city"}>{"City"}</label>
                      <input
                        type={"text"}
                        id={"city"}
                        required
                        ref={(el) => (frmRef.current["city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"state"}>{"State/Province/Region"}</label>
                      <input
                        type={"text"}
                        id={"state"}
                        required
                        ref={(el) => (frmRef.current["state"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"country"}
                        required
                        ref={(el) => (frmRef.current["country"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"zip_code"}>
                        {"Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"zip_code"}
                        required
                        ref={(el) => (frmRef.current["zip_code"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"estimated_delivery_date"}>
                        {"Estimated Delivery Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"estimated_delivery_date"}
                        required
                        min={currentDate}
                        value={expectedDate}
                        onChange={handleExpectedDateChange}
                        ref={(el) =>
                          (frmRef.current["estimated_delivery_date"] = el)
                        }
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="row">
                    {" "}
                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4"> </div>
                    <div className="col-md-4"> </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default DeliveryDispatchCLForm;
